import { createClient as createSupabaseClient } from "@supabase/supabase-js"
import type { Database } from "@/types/supabase"

// Singleton pattern para o cliente Supabase
let supabaseClientInstance: ReturnType<typeof createSupabaseClient<Database>> | null = null

// Função para criar um cliente Supabase
export function createSupabaseClientFunction() {
  const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL || ""
  const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || ""

  if (!supabaseClientInstance) {
    supabaseClientInstance = createSupabaseClient<Database>(supabaseUrl, supabaseAnonKey)
  }

  return supabaseClientInstance
}

export const createClient = createSupabaseClientFunction

// Exporta o cliente Supabase inicializado
export const supabaseClient = createSupabaseClientFunction()

export const supabase = supabaseClient
